
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { getToken, IsModemAccess, utc_local } from '../../../helpers/Helper';
import { del, post } from '../../../helpers/api_helper';
import { POST_USERS_LIST, DELETE_USERS, POST_ADMIN_USERS_STATUS } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import ReactDOM from 'react-dom/client';
import useMounted from '../../../hooks/useMounted';

import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";


const UserRoles = (props) => {
    const navigate = useNavigate();
    const [userId, SetUserId] = useState(0);


    useMounted(() => {
        get_user()
    })

    const get_user = () => {
        const tableElement = $('#dataTableExample');
        if (tableElement.length > 0) {
            tableElement.DataTable({
                destroy: true,
                "bProcessing": true,
                "bServerSide": true,
                'searching': true,
                'stateSave': true,
                "scrollX": false,
                "sServerMethod": "POST",
                "order": [[0, 'desc']],
                columnDefs: [
                    { orderable: false, targets: [7,8,9] },
                    { "targets": 0, "visible": false }
                ],
                "ajax": function (data, callback, settings) {
                    data.sSearch = data.search.value;
                    data.iDisplayLength = data.length;
                    data.iDisplayStart = data.start;
                    data.sSortDir_0 = (data.order.length > 0) ? data.order[0].dir : '';
                    data.iSortCol_0 = (data.order.length > 0) ? data.order[0].column : '';

                    $.ajax({
                        "url": POST_USERS_LIST,
                        "type": "POST",
                        "data": data,
                        "headers": { 'Authorization': getToken() },
                        "error": function (xhr, status, error) {
                            if (xhr.status === 401) {
                                navigate("/logout");
                            }
                        },
                        "success": callback
                    });
                },
                "columns": [
                    { "data": "userId" },
                    { "data": "name" },
                    { "data": "mobileNo" },
                    { "data": "email" },
                    { "data": "emailVerified" },
                    { "data": "countryName" },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {utc_local(data.createdAt)}
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <a href={`https://check-host.net/ip-info?host=${data.userIpAddress}`} className='text-primary' target="_blank" rel="noopener noreferrer">{data.userIpAddress}</a>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                <button onClick={UpdateStatus.bind(this, data.userId, data.userStatus)} className={`border-0 badge ${(data.userStatus === 'Active') ? 'bg-success' : 'bg-danger'}`}>{data.userStatus}</button>
                            </>)
                        }
                    },
                    {
                        "data": null, 'createdCell': (td, data) => {
                            const root = ReactDOM.createRoot(td);
                            root.render(<>
                                {IsModemAccess('user', 'edit') && <button className="btn btn-sm text-primary" onClick={() => { navigate('/admin/users/view/' + data.userId); }}><i style={{"fontSize" : "16px"}} className="fa fa-eye align-middle"></i></button>}
                                <a href={`/?id=${data.userId}`} className='btn btn-sm' target="_blank" rel="noreferrer"><i className="bx bx-log-in align-middle text-primary"></i></a>
                                {IsModemAccess('user', 'delete') && <button className="btn btn-sm text-danger" onClick={() => { SetUserId(data.userId); }} data-bs-toggle="modal" data-bs-target="#deleteModal" ><i className="bx bx-trash-alt align-middle"></i></button>}
                            </>)
                        }
                    },
                ]
            });
        }
    }

    //UpdateStatus
    const UpdateStatus = async (userId, status) => {
        if (!IsModemAccess('user', 'edit')) {
            toast.error('Does not permission this module');
            return;
        }
        var res_data = await post(POST_ADMIN_USERS_STATUS, { userId: userId, status: status });
        if (res_data.status) {
            toast(res_data.message);
            get_user();
        } else {
            toast.error(res_data.message);
        }
    }

    // remove user role
    const remove_row = async () => {
        var res_data = await del(DELETE_USERS + "?userId=" + userId);
        if (res_data.status) {
            toast(res_data.message);
            get_user();
        } else {
            toast.error(res_data.message);
        }
    }

    function openInPrivateWindow(url) {
        // Check if URL is provided and valid
        if (!url) {
          console.error("Please provide a valid URL");
          return;
        }
        
        // Different browsers have different window features for private browsing
        const windowFeatures = "width=800,height=600";
        
        // Try to open in private mode using different browser syntaxes
        try {
          // Chrome & Opera (incognito)
          window.open(url, "_blank", `${windowFeatures},incognito=yes`);
          
          // Firefox (private)
          // Safari (private)
          // Edge (private)
          // The below will fall back to a regular window in browsers that don't support these features
          window.open(url, "_blank", `${windowFeatures},private=yes`);
        } catch (error) {
          console.error("Failed to open private window:", error);
          // Fallback to regular window
          window.open(url, "_blank", windowFeatures);
        }
      }
    return (
        <>
            <div className='row'>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mb-4">
                    <div className="card">
                        <div className="card-body">
                            <div className='row mb-3'>
                                <div className='col-sm-6'>
                                    <h5 className='mt-1'>Users</h5>
                                </div>
                                <div className='col-sm-6 text-right'>
                                </div>
                            </div>
                            <hr />
                            <div className='table-responsive text-nowrap'>
                                {IsModemAccess('user', 'view') &&
                                    <table id="dataTableExample" className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Id</td>
                                                <td>Name</td>
                                                <td>Mobile No</td>
                                                <td>Email</td>
                                                <td>Email Verified</td>
                                                <td>Country</td>
                                                <td>Reg Date</td>
                                                <td>Ip Address</td>
                                                <td>Status</td>
                                                <td>Action</td>
                                            </tr>
                                        </thead>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="deleteModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm Delete</h5>
                            <button type="button" className="btn btn-sm close" data-bs-dismiss="modal" aria-label="Close">
                                <i className="bx bx-x"></i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this record?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">No</button>
                            <button onClick={remove_row.bind(this)} data-bs-dismiss="modal" className="btn btn-primary">Yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UserRoles;